// Action Types
export const SHOW_EXTENDED_MODAL = 'ticketsScanner/ui/SHOW_EXTENDED_MODAL'
export const DISMISS_EXTENDED_MODAL = 'ticketsScanner/ui/DISMISS_EXTENDED_MODAL'
export const RESET_UI = 'ticketsScanner/ui/RESET_UI'

// Initial State
const initialState = {
  showExtendedModal: false,
  resetTrigger: 0, // Increment to trigger reset
}

// Reducer
export default function uiReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_EXTENDED_MODAL:
      return {
        ...state,
        showExtendedModal: true,
      }

    case DISMISS_EXTENDED_MODAL:
      return {
        ...state,
        showExtendedModal: false,
      }

    case RESET_UI:
      return {
        ...state,
        resetTrigger: state.resetTrigger + 1,
      }

    default:
      return state
  }
}

// Action Creators
export const showExtendedModal = () => ({
  type: SHOW_EXTENDED_MODAL,
})

export const dismissExtendedModal = () => ({
  type: DISMISS_EXTENDED_MODAL,
})

export const resetUI = () => ({
  type: RESET_UI,
})

// Selectors
export const selectShowExtendedModal = (state) => state.ticketsScanner?.ui?.showExtendedModal || false
export const selectResetTrigger = (state) => state.ticketsScanner?.ui?.resetTrigger || 0
